import { getAppointments } from '@/http/classesApi';
import { getAppointmentsQueryKey } from '@/utils/queryKeys';
import { useQuery } from '@tanstack/react-query';
import { getCookie } from '@/utils/cookies';

type UseGetAppointmentsQueryParams = {
  activeOnly?: boolean;
};

export const useGetAppointmentsQuery = (params?: UseGetAppointmentsQueryParams) => {
  const { activeOnly = true } = params || {};
  const userToken = getCookie('user_token');
  return useQuery({
    queryKey: getAppointmentsQueryKey(),
    queryFn: () => getAppointments(userToken),
    select: (response) => {
      if (activeOnly) {
        return response.data.data.filter((data) =>
          ['planned', 'temporarily_reserved_need_payment'].includes(data.status),
        );
      }

      return response.data.data;
    },
  });
};
